const DEFAULT_TIMEOUT_ERROR = 'Operation timed out';

export async function withTimeout<T>(
  promise: Promise<T>,
  timeoutMs: number,
  errorMessage = DEFAULT_TIMEOUT_ERROR
): Promise<T> {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  try {
    return await Promise.race<T>([
      promise,
      new Promise<T>((_, reject) => {
        timeoutId = setTimeout(() => reject(new Error(errorMessage)), timeoutMs);
      }),
    ]);
  } finally {
    if (timeoutId) clearTimeout(timeoutId);
  }
}
